import { supabase } from '../lib/supabaseClient';

export type AudienceRole = 'fresher' | 'working_professional';
export type ModalOpenedFrom = 'signin' | 'signup';

/** Persists notify-me / waitlist submissions from the marketing launch modal (Header). */
export async function submitLaunchWaitlistEntry(params: {
  email: string;
  audienceRole: AudienceRole;
  companyName: string | null;
  openedFrom: ModalOpenedFrom;
}): Promise<{ error: Error | null; duplicate: boolean }> {
  const row = {
    email: params.email.trim().toLowerCase(),
    audience_role: params.audienceRole,
    company_name: params.companyName && params.companyName.trim() !== '' ? params.companyName.trim() : null,
    opened_from: params.openedFrom,
  };

  const { error } = await supabase.from('launch_waitlist_entries').insert(row);

  if (error) {
    const isDuplicate =
      error.code === '23505' ||
      /WAITLIST_EMAIL_EXISTS/i.test(error.message) ||
      /duplicate/i.test(error.message);
    if (isDuplicate) {
      return { error: null, duplicate: true };
    }
    return { error: new Error(error.message), duplicate: false };
  }

  return { error: null, duplicate: false };
}
